import React from 'react';
import { useIntl } from 'react-intl';
import { SidebarPortal, BlockDataForm } from '@plone/volto/components';
import MermaidDiagram from './MermaidDiagram';
import { diagramSchema, messages } from '../schema';
import './diagram.css';

const DEBOUNCE_MS = 600;

// Main-area monospace source textarea + debounced live preview (the same
// renderer as View, so error degradation in the editor comes free).
// kind + caption live in the sidebar schema.
const DiagramEdit = (props) => {
  const { data, block, onChangeBlock, selected } = props;
  const intl = useIntl();
  const source = data.source || '';
  const [preview, setPreview] = React.useState(source);

  React.useEffect(() => {
    const t = setTimeout(() => setPreview(source), DEBOUNCE_MS);
    return () => clearTimeout(t);
  }, [source]);

  return (
    <div className="diagram-block diagram-block--edit">
      <textarea
        className="diagram-source-input"
        aria-label={intl.formatMessage(messages.source)}
        value={source}
        placeholder={'graph TD\n  A --> B'}
        spellCheck={false}
        rows={Math.max(6, source.split('\n').length + 1)}
        onChange={(e) => onChangeBlock(block, { ...data, source: e.target.value })}
      />
      {preview ? <MermaidDiagram source={preview} /> : null}
      <SidebarPortal selected={selected}>
        <BlockDataForm
          schema={diagramSchema({ intl })}
          title="Diagram"
          onChangeField={(id, value) => onChangeBlock(block, { ...data, [id]: value })}
          formData={data}
          block={block}
        />
      </SidebarPortal>
    </div>
  );
};

export default DiagramEdit;
